import KiqStep from './KiqStep';

export default KiqStep;
